import { render } from "./account-info-show.vue?vue&type=template&id=52cf72b1"
import script from "./account-info-show.vue?vue&type=script&lang=js"
export * from "./account-info-show.vue?vue&type=script&lang=js"

import "./account-info-show.vue?vue&type=style&index=0&id=52cf72b1&lang=less"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__